import { useT } from "../lib/i18n";
import { ArrowLeft } from "lucide-react";
import { Link } from "react-router-dom";

export default function Terms() {
  const { t } = useT();
  return (
    <div className="min-h-screen bg-[#F8F5F2] text-[#1A1A1A]">
      <div className="max-w-3xl mx-auto px-4 md:px-8 py-16">
        <Link to="/" className="inline-flex items-center gap-2 text-sm text-ink2 hover:text-[#6E1A24] mb-8">
          <ArrowLeft className="w-4 h-4" /> ← Back
        </Link>
        <h1 className="heading-poster text-4xl md:text-5xl mb-8">Terms & Conditions / Regulamin</h1>
        <div className="prose prose-lg max-w-none space-y-6 text-ink2">
          <h2>English</h2>
          <p><strong>1. General.</strong> By purchasing a ticket you agree to these terms. The event is organized by Connect & Elevate Network.</p>
          <p><strong>2. Tickets.</strong> Tickets are personal and non-transferable unless agreed with the organizer. Each ticket grants access to the conference program as described on the website.</p>
          <p><strong>3. Conduct.</strong> Attendees must behave respectfully. The organizer reserves the right to remove anyone who disrupts the event without refund.</p>
          <p><strong>4. Liability.</strong> The organizer is not responsible for personal belongings. Attendance is at your own risk.</p>
          <p><strong>5. Changes.</strong> The organizer reserves the right to change the program, speakers, or venue. In case of cancellation, full refunds will be issued.</p>
          <p><strong>6. Media.</strong> By attending, you consent to being photographed and filmed. Materials may be used for promotional purposes.</p>

          <hr className="border-[#E2D8CF]" />

          <h2>Polski</h2>
          <p><strong>1. Postanowienia ogólne.</strong> Kupując bilet, akceptujesz niniejszy regulamin. Wydarzenie organizuje Connect & Elevate Network.</p>
          <p><strong>2. Bilety.</strong> Bilety są imienne i niezbywalne bez zgody organizatora. Każdy bilet daje dostęp do programu konferencji opisanego na stronie.</p>
          <p><strong>3. Zachowanie.</strong> Uczestnicy zobowiązani są do zachowania szacunku. Organizator zastrzega sobie prawo do usunięcia osoby zakłócającej wydarzenie bez zwrotu kosztów.</p>
          <p><strong>4. Odpowiedzialność.</strong> Organizator nie ponosi odpowiedzialności za rzeczy osobiste. Udział w wydarzeniu odbywa się na własne ryzyko.</p>
          <p><strong>5. Zmiany.</strong> Organizator zastrzega sobie prawo do zmiany programu, prelegentów lub lokalizacji. W przypadku odwołania wydarzenia, bilety zostaną zwrócone w pełnej kwocie.</p>
          <p><strong>6. Wizerunek.</strong> Uczestnicząc w wydarzeniu, wyrażasz zgodę na utrwalanie wizerunku. Materiały mogą być wykorzystane w celach promocyjnych.</p>
        </div>
      </div>
    </div>
  );
}
